module.exports = __webpack_public_path__ + "static/media/details-22-image-4.2dd9c7c5.jpg";